import type { Program } from 'models';
import { EditEvent } from 'features/events';

type Draft = {
  event: { id: string };
  type?: string;
};

type P = {
  draft?: Draft;
  isOpenEditorModal: boolean;
  onRequestClose: () => void;
  onSubmit?: () => void;
  program: Program;
};

const UpdateTimelineObject = ({ draft, isOpenEditorModal, onRequestClose, onSubmit, program }: P) => {
  if (draft?.type !== 'event') {
    return null;
  }

  return (
    <EditEvent
      eventId={draft.event.id}
      isOpened={isOpenEditorModal}
      mode="edit"
      onCancel={onRequestClose}
      onSuccess={onSubmit ?? onRequestClose}
      program={program}
    />
  );
};

export default UpdateTimelineObject;
